import script from "./Analyses.vue?vue&type=script&setup=true&lang=js"
export * from "./Analyses.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__